// BSC Slider JavaScript with Snow, Stars and Hill Effect
(function() {
  'use strict';
  
  // Snow Effect Class with Hill Formation
  function SnowEffect(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.snowflakes = [];
    this.animationId = null;
    this.isRunning = false;
    
    // Get settings from data attributes
    this.count = parseInt(canvas.getAttribute('data-snow-count')) || 100;
    this.speed = parseInt(canvas.getAttribute('data-snow-speed')) || 3;
    this.opacity = (parseInt(canvas.getAttribute('data-snow-opacity')) || 80) / 100;
    this.sizeMin = parseInt(canvas.getAttribute('data-snow-size-min')) || 2;
    this.sizeMax = parseInt(canvas.getAttribute('data-snow-size-max')) || 5;
    
    // Hill settings
    this.showHill = canvas.getAttribute('data-show-hill') === 'true';
    this.hillDuration = parseInt(canvas.getAttribute('data-hill-duration')) || 5000;
    this.hillInterval = parseInt(canvas.getAttribute('data-hill-interval')) || 10000;
    this.hillColor = getComputedStyle(canvas.closest('.html-css-slider-section')).getPropertyValue('--hill-color').trim() || '#ffffff';
    
    // Hill state
    this.hillVisible = false;
    this.hillProgress = 0; // 0 to 1 (appearing) or 1 to 0 (disappearing)
    this.hillAnimating = false;
    this.hillTimeout = null;
    this.hillIntervalId = null;
    
    this.init();
  }
  
  SnowEffect.prototype.init = function() {
    this.resizeCanvas();
    this.createSnowflakes();
    this.start();
    
    var self = this;
    window.addEventListener('resize', function() {
      self.resizeCanvas();
    });
    
    // Start hill cycle if enabled
    if (this.showHill) {
      this.startHillCycle();
    }
  };
  
  SnowEffect.prototype.resizeCanvas = function() {
    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;
  };
  
  SnowEffect.prototype.createSnowflakes = function() {
    this.snowflakes = [];
    for (var i = 0; i < this.count; i++) {
      this.snowflakes.push(this.createSnowflake());
    }
  };
  
  SnowEffect.prototype.createSnowflake = function() {
    return {
      x: Math.random() * this.canvas.width,
      y: Math.random() * this.canvas.height,
      radius: Math.random() * (this.sizeMax - this.sizeMin) + this.sizeMin,
      density: Math.random() * this.speed + 1,
      drift: Math.random() * 0.5 - 0.25
    };
  };
  
  SnowEffect.prototype.update = function() {
    for (var i = 0; i < this.snowflakes.length; i++) {
      var flake = this.snowflakes[i];
      
      flake.y += flake.density;
      flake.x += flake.drift;
      
      if (flake.y > this.canvas.height) {
        flake.y = -10;
        flake.x = Math.random() * this.canvas.width;
      }
      
      if (flake.x > this.canvas.width) {
        flake.x = 0;
      } else if (flake.x < 0) {
        flake.x = this.canvas.width;
      }
    }
  };
  
  SnowEffect.prototype.draw = function() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    
    // Draw snowflakes
    this.ctx.fillStyle = 'rgba(255, 255, 255, ' + this.opacity + ')';
    this.ctx.beginPath();
    
    for (var i = 0; i < this.snowflakes.length; i++) {
      var flake = this.snowflakes[i];
      this.ctx.moveTo(flake.x, flake.y);
      this.ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2, true);
    }
    
    this.ctx.fill();
    
    // Draw hill if visible
    if (this.showHill && this.hillProgress > 0) {
      this.drawHill();
    }
  };
  
  SnowEffect.prototype.drawHill = function() {
    var width = this.canvas.width;
    var height = this.canvas.height;
    var maxHeight = height * 0.25; // Hill can be up to 25% of canvas height
    var currentHeight = maxHeight * this.hillProgress;
    
    this.ctx.save();
    
    // Create gradient for hill
    var gradient = this.ctx.createLinearGradient(0, height - currentHeight, 0, height);
    gradient.addColorStop(0, this.hillColor);
    gradient.addColorStop(1, this.hillColor);
    
    this.ctx.fillStyle = gradient;
    this.ctx.globalAlpha = 0.9;
    
    // Draw wavy hill shape
    this.ctx.beginPath();
    this.ctx.moveTo(0, height);
    
    // Create multiple waves across the width
    var waves = 4;
    var waveHeight = currentHeight * 0.3;
    
    for (var i = 0; i <= waves; i++) {
      var x = (width / waves) * i;
      var y = height - currentHeight + Math.sin((i / waves) * Math.PI * 2) * waveHeight;
      
      if (i === 0) {
        this.ctx.lineTo(x, y);
      } else {
        var prevX = (width / waves) * (i - 1);
        var prevY = height - currentHeight + Math.sin(((i - 1) / waves) * Math.PI * 2) * waveHeight;
        var cpX = (prevX + x) / 2;
        var cpY = (prevY + y) / 2 - waveHeight * 0.5;
        
        this.ctx.quadraticCurveTo(cpX, cpY, x, y);
      }
    }
    
    this.ctx.lineTo(width, height);
    this.ctx.lineTo(0, height);
    this.ctx.closePath();
    this.ctx.fill();
    
    this.ctx.restore();
  };
  
  SnowEffect.prototype.startHillCycle = function() {
    var self = this;
    
    // Initial delay before first hill
    this.hillTimeout = setTimeout(function() {
      self.showHillAnimation();
      
      // Set up recurring interval
      self.hillIntervalId = setInterval(function() {
        self.showHillAnimation();
      }, self.hillInterval);
    }, this.hillInterval);
  };
  
  SnowEffect.prototype.showHillAnimation = function() {
    var self = this;
    
    // Animate hill appearing (0 to 1)
    this.hillVisible = true;
    this.hillAnimating = true;
    var appearDuration = 1500; // 1.5 seconds to appear
    var startTime = Date.now();
    
    function animateAppear() {
      if (!self.hillAnimating) return;
      
      var elapsed = Date.now() - startTime;
      self.hillProgress = Math.min(elapsed / appearDuration, 1);
      
      if (self.hillProgress < 1) {
        requestAnimationFrame(animateAppear);
      } else {
        // Hill fully visible, wait then disappear
        setTimeout(function() {
          self.hideHillAnimation();
        }, self.hillDuration);
      }
    }
    
    animateAppear();
  };
  
  SnowEffect.prototype.hideHillAnimation = function() {
    var self = this;
    
    // Animate hill disappearing (1 to 0)
    var disappearDuration = 1500; // 1.5 seconds to disappear
    var startTime = Date.now();
    
    function animateDisappear() {
      if (!self.hillAnimating) return;
      
      var elapsed = Date.now() - startTime;
      self.hillProgress = Math.max(1 - (elapsed / disappearDuration), 0);
      
      if (self.hillProgress > 0) {
        requestAnimationFrame(animateDisappear);
      } else {
        self.hillVisible = false;
        self.hillAnimating = false;
      }
    }
    
    animateDisappear();
  };
  
  SnowEffect.prototype.animate = function() {
    var self = this;
    this.update();
    this.draw();
    this.animationId = requestAnimationFrame(function() {
      self.animate();
    });
  };
  
  SnowEffect.prototype.start = function() {
    if (!this.isRunning) {
      this.isRunning = true;
      this.animate();
    }
  };
  
  SnowEffect.prototype.stop = function() {
    if (this.isRunning) {
      this.isRunning = false;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
  };
  
  SnowEffect.prototype.destroy = function() {
    this.stop();
    this.hillAnimating = false;
    
    if (this.hillTimeout) {
      clearTimeout(this.hillTimeout);
      this.hillTimeout = null;
    }
    
    if (this.hillIntervalId) {
      clearInterval(this.hillIntervalId);
      this.hillIntervalId = null;
    }
    
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  };
  
  // Stars Effect Class (Image-based)
  function StarsEffect(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.stars = [];
    this.animationId = null;
    this.isRunning = false;
    this.imagesLoaded = false;
    
    // Get settings from data attributes
    this.count = parseInt(canvas.getAttribute('data-stars-count')) || 40;
    this.speed = parseInt(canvas.getAttribute('data-stars-speed')) || 2;
    this.opacity = (parseInt(canvas.getAttribute('data-stars-opacity')) || 90) / 100;
    this.sizeMin = parseInt(canvas.getAttribute('data-stars-size-min')) || 12;
    this.sizeMax = parseInt(canvas.getAttribute('data-stars-size-max')) || 22;
    
    // Fallback: Use data URL of a proper SQUARE snowflake SVG (100x100)
    this.fallbackImage = 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/2744.png';
    
    this.images = [];
    this.loadImages();
  }
  
  StarsEffect.prototype.loadImages = function() {
    var self = this;
    var loadedCount = 0;
    var totalImages = 1; // Just load fallback for reliability
    
    // Load fallback image
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function() {
      self.images.push(img);
      loadedCount++;
      if (loadedCount === totalImages) {
        self.imagesLoaded = true;
        self.init();
      }
    };
    img.onerror = function() {
      // If even fallback fails, create images array anyway
      self.images.push(img);
      loadedCount++;
      if (loadedCount === totalImages) {
        self.imagesLoaded = true;
        self.init();
      }
    };
    img.src = this.fallbackImage;
  };
  
  StarsEffect.prototype.init = function() {
    if (!this.imagesLoaded) return;
    
    this.resizeCanvas();
    this.createStars();
    this.start();
    
    var self = this;
    window.addEventListener('resize', function() {
      self.resizeCanvas();
    });
  };
  
  StarsEffect.prototype.resizeCanvas = function() {
    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;
  };
  
  StarsEffect.prototype.createStars = function() {
    this.stars = [];
    for (var i = 0; i < this.count; i++) {
      this.stars.push(this.createStar());
    }
  };
  
  StarsEffect.prototype.createStar = function() {
    var imageIndex = Math.floor(Math.random() * this.images.length);
    
    return {
      x: Math.random() * this.canvas.width,
      y: Math.random() * this.canvas.height,
      size: Math.random() * (this.sizeMax - this.sizeMin) + this.sizeMin,
      speed: Math.random() * this.speed + 0.5,
      drift: Math.random() * 0.3 - 0.15,
      twinkle: Math.random(),
      twinkleSpeed: Math.random() * 0.02 + 0.01,
      image: this.images[imageIndex]
    };
  };
  
  StarsEffect.prototype.update = function() {
    for (var i = 0; i < this.stars.length; i++) {
      var star = this.stars[i];
      
      star.y += star.speed;
      star.x += star.drift;
      star.twinkle += star.twinkleSpeed;
      
      if (star.twinkle > Math.PI * 2) {
        star.twinkle = 0;
      }
      
      if (star.y > this.canvas.height + star.size) {
        star.y = -star.size;
        star.x = Math.random() * this.canvas.width;
      }
      
      if (star.x > this.canvas.width + star.size) {
        star.x = -star.size;
      } else if (star.x < -star.size) {
        star.x = this.canvas.width + star.size;
      }
    }
  };
  
  StarsEffect.prototype.draw = function() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    
    for (var i = 0; i < this.stars.length; i++) {
      var star = this.stars[i];
      var twinkleOpacity = (Math.sin(star.twinkle) * 0.5 + 0.5) * this.opacity;
      
      this.ctx.save();
      this.ctx.globalAlpha = twinkleOpacity;
      
      // Force square dimensions - both width and height are the same
      var squareSize = star.size;
      
      // Draw image as perfect square
      this.ctx.drawImage(
        star.image,
        star.x - squareSize / 2,
        star.y - squareSize / 2,
        squareSize,
        squareSize
      );
      
      this.ctx.restore();
    }
  };
  
  StarsEffect.prototype.animate = function() {
    var self = this;
    this.update();
    this.draw();
    this.animationId = requestAnimationFrame(function() {
      self.animate();
    });
  };
  
  StarsEffect.prototype.start = function() {
    if (!this.isRunning) {
      this.isRunning = true;
      this.animate();
    }
  };
  
  StarsEffect.prototype.stop = function() {
    if (this.isRunning) {
      this.isRunning = false;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
  };
  
  StarsEffect.prototype.destroy = function() {
    this.stop();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  };
  
  // Slider Function
  function initSlider(sliderElement) {
    if (!sliderElement) return;
    
    const slidesContainer = sliderElement.querySelector('.bsc-slides');
    const slides = sliderElement.querySelectorAll('.bsc-slide');
    const dots = sliderElement.querySelectorAll('.bsc-dot');
    const prevBtn = sliderElement.querySelector('.bsc-arrow-prev');
    const nextBtn = sliderElement.querySelector('.bsc-arrow-next');
    
    if (!slidesContainer || slides.length === 0) return;
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    const autoplay = sliderElement.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(sliderElement.getAttribute('data-autoplay-speed')) || 5000;
    const fadeEffect = sliderElement.getAttribute('data-fade') === 'true';
    let autoplayInterval = null;
    let slideWidth = 100;
    
    slidesContainer.style.width = (totalSlides * 100) + '%';
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.width = slideWidth + '%';
    }
    
    function updateSlider() {
      if (fadeEffect) {
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.opacity = i === currentSlide ? '1' : '0';
          slides[i].style.transition = 'opacity 0.5s ease-in-out';
        }
      } else {
        const translateX = -currentSlide * slideWidth;
        slidesContainer.style.transform = 'translateX(' + translateX + '%)';
      }
      
      for (let i = 0; i < dots.length; i++) {
        if (i === currentSlide) {
          dots[i].classList.add('bsc-dot-active');
        } else {
          dots[i].classList.remove('bsc-dot-active');
        }
      }
      
      for (let i = 0; i < slides.length; i++) {
        if (i === currentSlide) {
          slides[i].classList.add('bsc-active');
        } else {
          slides[i].classList.remove('bsc-active');
        }
      }
    }
    
    function nextSlide() {
      currentSlide = (currentSlide + 1) % totalSlides;
      updateSlider();
    }
    
    function prevSlide() {
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
      updateSlider();
    }
    
    function goToSlide(index) {
      if (index >= 0 && index < totalSlides) {
        currentSlide = index;
        updateSlider();
      }
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        nextSlide();
        resetAutoplay();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prevSlide();
        resetAutoplay();
      });
    }
    
    for (let i = 0; i < dots.length; i++) {
      const button = dots[i].querySelector('button');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          goToSlide(i);
          resetAutoplay();
        });
      }
    }
    
    function startAutoplay() {
      if (autoplay && totalSlides > 1) {
        autoplayInterval = setInterval(function() {
          nextSlide();
        }, autoplaySpeed);
      }
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    function resetAutoplay() {
      stopAutoplay();
      setTimeout(function() {
        startAutoplay();
      }, 100);
    }
    
    sliderElement.addEventListener('mouseenter', function() {
      stopAutoplay();
    });
    
    sliderElement.addEventListener('mouseleave', function() {
      startAutoplay();
    });
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    sliderElement.addEventListener('touchstart', function(e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchStartX = e.changedTouches[0].screenX;
      }
    });
    
    sliderElement.addEventListener('touchend', function(e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }
    });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        resetAutoplay();
      }
    }
    
    function handleResize() {
      updateSlider();
    }
    
    window.addEventListener('resize', handleResize);
    
    if (fadeEffect) {
      slidesContainer.style.display = 'block';
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.position = 'absolute';
        slides[i].style.top = '0';
        slides[i].style.left = '0';
        slides[i].style.width = '100%';
        slides[i].style.opacity = i === 0 ? '1' : '0';
      }
    }
    
    updateSlider();
    startAutoplay();
    
    return function cleanup() {
      stopAutoplay();
      window.removeEventListener('resize', handleResize);
    };
  }
  
  // Store initialized sliders and effects
  const initializedSliders = new Map();
  const snowEffects = new Map();
  const starsEffects = new Map();
  
  function initAllSliders() {
    const sliders = document.querySelectorAll('.bsc-slider');
    
    for (let i = 0; i < sliders.length; i++) {
      const slider = sliders[i];
      const section = slider.closest('[data-section-id]');
      const sliderId = section?.getAttribute('data-section-id') || 'slider-' + i;
      
      if (initializedSliders.has(sliderId)) {
        const cleanup = initializedSliders.get(sliderId);
        if (typeof cleanup === 'function') {
          cleanup();
        }
      }
      
      const cleanup = initSlider(slider);
      if (cleanup) {
        initializedSliders.set(sliderId, cleanup);
      }
      
      // Initialize snow effect if canvas exists
      if (section) {
        const snowCanvas = section.querySelector('.bsc-snow-canvas');
        if (snowCanvas) {
          if (snowEffects.has(sliderId)) {
            snowEffects.get(sliderId).destroy();
          }
          const snow = new SnowEffect(snowCanvas);
          snowEffects.set(sliderId, snow);
        }
        
        // Initialize stars effect if canvas exists
        const starsCanvas = section.querySelector('.bsc-stars-canvas');
        if (starsCanvas) {
          if (starsEffects.has(sliderId)) {
            starsEffects.get(sliderId).destroy();
          }
          const stars = new StarsEffect(starsCanvas);
          starsEffects.set(sliderId, stars);
        }
      }
    }
  }
  
  function domReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }
  
  domReady(function() {
    initAllSliders();
  });
  
  document.addEventListener('shopify:section:load', function(event) {
    if (event && event.target) {
      const slider = event.target.querySelector('.bsc-slider');
      if (slider) {
        setTimeout(function() {
          initSlider(slider);
          
          const snowCanvas = event.target.querySelector('.bsc-snow-canvas');
          if (snowCanvas) {
            const sectionId = event.target.getAttribute('data-section-id');
            if (sectionId && snowEffects.has(sectionId)) {
              snowEffects.get(sectionId).destroy();
            }
            const snow = new SnowEffect(snowCanvas);
            if (sectionId) {
              snowEffects.set(sectionId, snow);
            }
          }
          
          const starsCanvas = event.target.querySelector('.bsc-stars-canvas');
          if (starsCanvas) {
            const sectionId = event.target.getAttribute('data-section-id');
            if (sectionId && starsEffects.has(sectionId)) {
              starsEffects.get(sectionId).destroy();
            }
            const stars = new StarsEffect(starsCanvas);
            if (sectionId) {
              starsEffects.set(sectionId, stars);
            }
          }
        }, 100);
      }
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event && event.target) {
      const sectionId = event.target.getAttribute('data-section-id');
      if (sectionId) {
        if (initializedSliders.has(sectionId)) {
          const cleanup = initializedSliders.get(sectionId);
          if (typeof cleanup === 'function') {
            cleanup();
          }
          initializedSliders.delete(sectionId);
        }
        if (snowEffects.has(sectionId)) {
          snowEffects.get(sectionId).destroy();
          snowEffects.delete(sectionId);
        }
        if (starsEffects.has(sectionId)) {
          starsEffects.get(sectionId).destroy();
          starsEffects.delete(sectionId);
        }
      }
    }
  });
  
  window.BSCSlider = {
    init: initAllSliders,
    initSingle: initSlider
  };
  
})();